import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Contact() {
  const [result, setResult] = useState("");
  const [accordion, setAccordion] = useState([false, false, false, false]);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "ee0dfd82-330e-4471-ab1d-28a6b1bc0417");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const toggleAccordion = (index) => {
    setAccordion((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const faqs = [
    {
      question: "What is GEMX?",
      answer:
        "GemX is an AI-powered assistant that goes beyond simple tasks. It's your companion for calls, chats, and more, offering personalized support and learning from every interaction.",
    },
    {
      question: "Is GemX available on all devices?",
      answer:
        "GemX is available for Android, and in your web browsers. You can access it on your smartphone, tablet, or computer for seamless support wherever you go.",
    },
    {
      question: "What should I do if GemX isn't working correctly?",
      answer:
        "Check internet connection, reload the page once again, or contact support for help.",
    },
    {
      question: "Is my data safe with GemX?",
      answer:
        "Yes, we prioritize your privacy. Your data is securely stored and used only to improve your GemX experience.",
    },
    {
      question: "Does GemX record my conversations?",
      answer:
        "GemX may process information from your conversations to understand your needs and provide better assistance. However, this data is treated confidentially.",
    },
  ];

  return (
    <div
      className="min-h-screen text-white overflow-hidden flex flex-col justify-center"
      style={{
        backgroundImage: "url(/bg12.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <nav className="flex justify-center items-center p-4">
        <button onClick={() => navigate('/app')} className="text-white absolute left-4">
          <img
            src="https://img.icons8.com/?size=100&id=40217&format=png&color=FFFFFF"
            alt="back"
            className="w-6 h-6"
          />
        </button>
        <h1 className="text-3xl font-bold cursor-pointer" onClick={() => navigate('/app')}>
          GemX
        </h1>
      </nav>
      <main className="flex flex-col md:flex-row justify-around items-start p-4 gap-6">
        <section className="relative py-1 overflow-hidden">
          <div className="relative container px-4 mx-auto">
            <div className="max-w-5xl mx-auto">
              <div className="text-center mb-1">
                <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 dark:bg-slate-950 rounded-full">
                  FREQUENTLY ASK QUESTION
                </span>
                <h1 className="font-heading text-5xl xs:text-6xl md:text-5xl font-bold text-white mb-4">
                  <span>You ask? We </span>
                  <span className="font-serif italic">answer</span>
                </h1>
              </div>
              <div className="pt-4 sm:pt-8 px-8 sm:px-20 pb-18">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="flex cursor-pointer mb-8 pb-8 group w-full items-start justify-between border-b border-gray-100 text-left"
                    onClick={() => toggleAccordion(index)}
                  >
                    <div className="max-w-xl pr-5">
                      <h3
                        className={`text-xl font-semibold ${
                          accordion[index] ? "text-orange-900" : "text-white"
                        }`}
                      >
                        {faq.question}
                      </h3>
                      <div
                        className={`overflow-hidden transition-all duration-500 ease-in-out ${
                          accordion[index] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
                        }`}
                      >
                        <p className="text-lg text-white-500 mt-3">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                    <div className="pt-1">
                      {accordion[index] ? (
                        <span className="relative top-3">
                          <svg
                            width="17"
                            height="3"
                            viewBox="0 0 17 3"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.4619 0.045166H1.46194C1.19673 0.045166 0.942374 0.150523 0.754838 0.338059C0.567302 0.525596 0.461945 0.77995 0.461945 1.04517C0.461945 1.31038 0.567302 1.56474 0.754838 1.75227C0.942374 1.93981 1.19673 2.04517 1.46194 2.04517H15.4619C15.7272 2.04517 15.9815 1.93981 16.1691 1.75227C16.3566 1.56474 16.4619 1.31038 16.4619 1.04517C16.4619 0.77995 16.3566 0.525596 16.1691 0.338059C15.9815 0.150523 15.7272 0.045166 15.4619 0.045166Z"
                              fill="#FF460C"
                            />
                          </svg>
                        </span>
                      ) : (
                        <span className="relative top-1">
                          <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15.4619 7H9.46194V1C9.46194 0.734784 9.35659 0.48043 9.16905 0.292893C8.98151 0.105357 8.72716 0 8.46194 0C8.19673 0 7.94237 0.105357 7.75484 0.292893C7.5673 0.48043 7.46194 0.734784 7.46194 1V7H1.46194C1.19673 7 0.942374 7.10536 0.754838 7.29289C0.567302 7.48043 0.461945 7.73478 0.461945 8C0.461945 8.26522 0.567302 8.51957 0.754838 8.70711C0.942374 8.89464 1.19673 9 1.46194 9H7.46194V15C7.46194 15.2652 7.5673 15.5196 7.75484 15.7071C7.94237 15.8946 8.19673 16 8.46194 16C8.72716 16 8.98151 15.8946 9.16905 15.7071C9.35659 15.5196 9.46194 15.2652 9.46194 15V9H15.4619C15.7272 9 15.9815 8.89464 16.1691 8.70711C16.3566 8.51957 16.4619 8.26522 16.4619 8C16.4619 7.73478 16.3566 7.48043 16.1691 7.29289C15.9815 7.10536 15.7272 7 15.4619 7Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="p-6 rounded-lg w-full md:w-1/3">
          <h2 className="text-3xl mb-10">Contact us</h2>
          <form className="flex flex-col gap-10" onSubmit={onSubmit}>
            <input
              type="email"
              name="email"
              autoComplete="off"
              placeholder="Email address"
              className="p-4 rounded-lg h-12 border-none text-black dark:bg-slate-950 focus:outline-primary dark:focus-within:bg-black"
              required
            />
            <textarea
              placeholder="Query.."
              name="message"
              className="p-4 rounded-xl h-28 border-none text-black dark:bg-slate-950 focus:outline-none dark:focus-within:bg-black"
              maxLength="500"
              required
            ></textarea>
            <button
              type="submit"
              className="p-4 bg-white dark:bg-slate-950 focus:outline-primary dark:focus-within:bg-black text-white rounded-lg cursor-pointer h-12"
            >
              Send mail
            </button>
          </form>
          <span>{result}</span>
        </section>
      </main>
    </div>
  );
  
}
